<template>
  <v-container
    fluid
    class="pa-0">
    <v-row
      v-for="(bookingDetails, ind) in upComingInterviews"
      :key="ind">
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-overline pl-4 pr-4 pt-2 pb-2">
            {{ bookingDetails.title }}
          </v-card-title>
          <v-divider/>

          <v-card-text class="text--primary">
            <div v-if="bookingDetails.description!=''">{{ bookingDetails.description }} </div>
            <div><span class="font-weight-medium">Child: </span>{{ bookingDetails.pupilName }} </div>

            <div><span class="font-weight-medium">Date: </span>{{ bookingDetails.interviewDate }} at {{ bookingDetails.time }}</div>
            <div><span class="font-weight-medium">Location: </span>{{ bookingDetails.location }} </div>
            <div><span class="font-weight-medium">Teacher: </span>{{ bookingDetails.teacherName }} </div>
            <div><span
              class="font-weight-medium"
              v-if="bookingDetails.caregiverBoxComment!='' && bookingDetails.parentnotes!='' ">{{ bookingDetails.caregiverBoxComment }}: </span>{{ bookingDetails.parentnotes }} </div>

          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-chip
              :color="bookingDetails.color"
              class="white--text">{{ bookingDetails.status }}</v-chip>
            <v-spacer/>

            <v-btn
              icon
              @click.stop="goToPrint(bookingDetails.printUrl.link)">
              <v-icon>print</v-icon>
            </v-btn>

            <v-btn
              text
              color="red"
              icon
              @click.stop="openCancelDialog(bookingDetails.bookingId, bookingDetails.sessionId)">
              <v-icon>event_busy</v-icon>
            </v-btn>

            <v-btn
              text
              color="#FF9100"
              icon
              @click.stop="openRescheduleDialog(bookingDetails.bookingId, bookingDetails.sessionId, bookingDetails.caregiverBoxComment, bookingDetails.parentnotes)"
            >
              <v-icon>edit</v-icon>
            </v-btn>

          </v-card-actions>
        </v-card>

      </v-col>

    </v-row>

    <v-dialog
      persistent
      v-model="rescheduleDialog"
      max-width="500px">
      <v-card>
        <v-card-title>Edit Booking</v-card-title>
        <v-divider/>

        <v-row class="pa-2">
          <v-col>
            <v-select
              outlined
              label='Select new time slot'
              v-model="selectedTime"
              :items='sessionTimes'
              item-value="id"
              item-text='timeSlot'
              color="teal"
            >
              <template v-slot:item="{ on, item }">
                <v-list-item
                  v-on="on"
                  :disabled="item.disabled">{{ item.timeSlot }}
                  <v-spacer/>
                  <v-chip
                    text-color="white"
                    :color="item.color"
                    small
                  >{{ item.status }}</v-chip>
                </v-list-item>
              </template>
            </v-select>

            <v-textarea
              outlined
              v-if="withNotes && selectedTime!=''"
              clearable
              clear-icon="mdi-close-circle"
              :label="caregiverBoxLabel"
              v-model="parentNotes"
              rows="3"
              row-height="25"
              auto-grow
              color="teal"
            />

            <v-alert
              v-if="alert"
              :type="alertColor"
              dense
              text
            >
              {{ alertMsg }}
            </v-alert>

          </v-col>
        </v-row>

        <v-card-actions>
          <v-btn
            @click="closeEdit()"
            color="red"
            dark>
            CLOSE
          </v-btn>

          <v-spacer/>
          <v-btn
            v-if="selectedTime!=''"
            @click.stop="editInterview()"
            color="cyan"
            dark>
            EDIT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="cancelDialog"
      max-width="500px">
      <v-card>
        <v-card-title>Cancel Booking</v-card-title>
        <v-divider/>

        <v-row class="pa-2">
          <v-col>
            <v-card-text>Do you really want to cancel this booking?</v-card-text>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-btn
            @click="closeCancelDialog()"
            color="red"
            dark>
            NO
          </v-btn>

          <v-spacer/>
          <v-btn
            @click.stop="cancelInterview()"
            color="cyan"
            dark>
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    upComingInterviews: {
      type: Array,
      default: () => { return {} }
    }
  },

  components: {

  },

  data: function () {
    return {
      tealColor: '#00B0B9',
      alertMsg: '',
      alertColor: '',
      rescheduleDialog: false,
      selectedBookingId: '',
      selectedSessionId: '',
      sessionTimes: [],
      selectedTime: '',
      selectRules: [
        v => !!v || 'This field is required'
      ],
      withNotes: false,
      caregiverBoxLabel: '',
      parentNotes: '',
      updatedInterview: [],

      selectedCancelId: '',
      selectedCancelSession: '',
      cancelDialog: false
    }
  },

  computed: {
    ...mapState(['Dbasename', 'schoolId', 'status', 'teacherId', 'teacherName', 'loadingDialog', 'withPinSetup']),
    alert: function () {
      if (this.alertMsg !== '') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    cancelInterview: function () {
      this.$store.commit('loading', true)

      this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/cancelbookingV2', {
        bookingId: this.selectedCancelId,
        sessionId: this.selectedCancelSession
      }).then(resp => {
        console.log(resp.data)

        if (resp.status === 200) {
          this.alertColor = 'success'
          this.alertMsg = 'Booked Successfully'
          this.selectedCancelSession = ''
          this.selectedCancelId = ''
          this.$store.commit('loading', false)
          this.$emit('get-upcoming-interview')
          this.cancelDialog = false
        } else {
          this.alertColor = 'error'
          this.alertMsg = resp.data.message

          this.$store.commit('loading', false)
        }
      })
    },
    closeCancelDialog: function () {
      this.selectedCancelId = ''
      this.selectedCancelSession = ''
      this.cancelDialog = false
      this.$emit('get-upcoming-interview')
    },
    openCancelDialog: function (bookingId, sessionId) {
      this.selectedCancelId = bookingId
      this.selectedCancelSession = sessionId
      this.cancelDialog = true
    },
    closeEdit: function () {
      this.rescheduleDialog = false
      this.selectedBookingId = ''
      this.selectedSessionId = ''
      this.sessionTimes = []
      this.alertMsg = ''
      this.alertColor = ''
      this.selectedTime = ''
      this.parentNotes = ''
      this.$emit('get-upcoming-interview')
    },
    openRescheduleDialog: function (bookingId, sessionId, withN, oldNote) {
      this.selectedBookingId = bookingId
      this.selectedSessionId = sessionId

      if (withN !== '') {
        this.withNotes = true
        this.caregiverBoxLabel = withN
        this.parentNotes = oldNote
      }

      this.$store.commit('loading', true)

      this.$http.get('bookingsV2/' + this.Dbasename + '/' + this.selectedBookingId + '/sessionTimesV2')
        .then(resp => {
          this.sessionTimes = resp.data
          this.$store.commit('loading', false)
        })

      this.rescheduleDialog = true
    },
    editInterview: function () {
      this.alertMsg = ''
      this.alertColor = ''
      this.$store.commit('loading', true)

      this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/editBookingV2', {
        bookingId: this.selectedBookingId,
        newsessionId: this.selectedTime,
        oldsessionId: this.selectedSessionId,
        parentNotes: this.parentNotes
      }).then(resp => {
        console.log(resp.data)

        this.alertColor = 'success'
        this.alertMsg = 'Booked Successfully'
        this.selectedTime = ''
        this.parentNotes = ''
        this.selectedBookingId = ''
        this.selectedSessionId = ''
        this.sessionTimes = []
        this.$store.commit('loading', false)
      }).catch(err => {
        console.log(err)

        this.alertColor = 'error'
        this.alertMsg = (err.response && err.response.data && err.response.data.message) || 'Something went wrong, please try again.'

        this.$store.commit('loading', false)
      })
    },
    getEditedInterview: function () {
      this.$store.commit('loading', true)

      this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.trueUser + '/' + this.$store.state.pupilId + '/onGoingInterviewV2')
        .then(resp => {
          this.updatedInterview = resp.data.onGoingInterview
          this.$store.commit('loading', false)
        })
    },
    goToPrint: function (link) {
      window.open(link, '_blank')
    }
  }
}
</script>
